<template>
    <section class="page-content settings">
        <div class="wrap btn-position-wrap">
            <div class="users-settings-list">
                <div class="item-wrap" v-for="user in userList">
                    <div class="line-item hovered-line">
                        <div class="left-item">
                            <div class="el user-item" v-on:click="showCurrentUserProfile(user.id)">
                                <div class="avatar s-48">
                                    <md-avatar v-if="user.avatar" class="md-avatar-icon">
                                        <img :src="getImageSrc(user.avatar)">
                                    </md-avatar>
                                    <md-avatar v-else class="md-avatar-icon blue">
                                        {{ getUserInitials(user) }}
                                    </md-avatar>
                                </div>
                                <h3>{{ user.firstName + ' ' + user.lastName }} <small>{{ user.title }}</small></h3>
                            </div>
                            <div class="el email-item">
                                <a class="email-link">{{ user.email }}</a>
                            </div>
                        </div>
                        <div class="right-item">
                            <div class="el" v-if="isAdmin">
                                <div class="el admin-check" v-if="clientActive && isAdmin">
                                    <md-checkbox
                                        v-bind:disabled="user.isPrimaryContact === 1"
                                        :value="user.isPrimaryContact ? false : true"
                                        aria-label="Primary Contact"
                                        @change="toggleUserPrimaryContact(user)">
                                        Primary Contact
                                    </md-checkbox>
                                </div>
                                <div class="el admin-check" v-if="!clientActive && isAdmin && (user.id !== currentUser.id)">
                                    <md-checkbox
                                        :value="user.isAdmin ? false : true"
                                        aria-label="Administrator"
                                        @change="toggleUserAdmin(user)">
                                        Cortex Administrator
                                    </md-checkbox>
                                </div>
                                <md-button class="md-icon-button" @click="showCurrentUserProfile(user.id)">
                                    <md-icon>mode_edit</md-icon>
                                </md-button>
                                <md-button v-if="user.id !== currentUser.id" class="md-icon-button" @click="confirmDelete(user)">
                                    <md-icon>delete</md-icon>
                                </md-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom-btn-position">
                <div class="wrap">
                    <md-button @click="clickAddNewUsers()" class="add-tour-button md-fab md-accent md-primary">
                        <md-icon>add</md-icon>
                    </md-button>
                </div>
            </div>
        </div>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialog">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Are you sure you want to delete <b>{{ userToDeleteName }}</b>? This action cannot be undone.
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="deleteSelectedUser()">DELETE</md-button>
                <md-button class="ManualBtn ManualBtncancel" @click="closeDialog()">CANCEL</md-button>
            </md-dialog-actions>
        </md-dialog>
    </section>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import {deleteUser, updateUser} from '../../services/UserService.js';

export default {
  data: () => ({
    showDeleteDialog: false,
    userIdToDelete: null,
    userToDeleteName: null
  }),
  computed: {
    ...mapGetters('client', ['clientActive', 'currentClient']),
    ...mapGetters('user', ['userList', 'isAdmin', 'currentUser'])
  },
  methods: {
    ...mapActions('user', ['loadUserList', 'setUserToEdit']),
    getImageSrc (avatar) {
      return 'static/img/' + avatar;
    },
    getUserInitials (user) {
      let userInitials = '';
      if (user.firstName) {
        userInitials += user.firstName.charAt(0);
      }
      if (user.lastName) {
        userInitials += user.lastName.charAt(0);
      }
      if (userInitials.length < 1) {
        userInitials = 'NA';
      }
      return userInitials;
    },
    clickAddNewUsers () {
      this.$router.push('/settings/users/add');
    },
    confirmDelete (user) {
      this.showDeleteDialog = true;
      this.userIdToDelete = user.id;
      this.userToDeleteName = user.firstName + ' ' + user.lastName;
    },
    closeDialog () {
      this.showDeleteDialog = false;
      this.userIdToDelete = null;
      this.userToDeleteName = null;
    },
    async deleteSelectedUser () {
      await deleteUser(this.userIdToDelete)
        .then(response => {
          this.loadUsers();
        })
        .catch(error => {
          console.log(error.response.data);
        });
      this.showDeleteDialog = false;
      this.userIdToDelete = null;
      this.userToDeleteName = null;
    },
    loadUsers () {
      if (this.clientActive) {
        this.loadUserList(this.currentClient.id);
      } else {
        this.loadUserList();
      }
    },
    toggleUserAdmin (user) {
      user.isAdmin = !user.isAdmin;
      this.callUpdateUser(user);
    },
    toggleUserPrimaryContact (user) {
      for (let userInList of this.userList) {
        if (userInList.isPrimaryContact === 1 && userInList.clientId === this.currentClient.id) {
          userInList.isPrimaryContact = 0;
        } else if (userInList.id === user.id) {
          user.isPrimaryContact = 1;
          userInList = user;
        }
      }
      this.callUpdateUser(user);
    },
    async callUpdateUser (user) {
      await updateUser(user)
        .catch(error => {
          console.log(error.response.data);
        });
    },
    showCurrentUserProfile (userId) {
      for (let user of this.userList) {
        if (user.id === userId) {
          this.setUserToEdit(user);
          this.$router.push('/user');
          return;
        }
      }
    }
  },
  mounted () {
    this.loadUsers();
  }
};
</script>

<style lang="scss" scoped>
.bottom-btn-position {
    position: fixed !important;
    right: 12px !important;
    bottom: 32px !important;
    width: 500px;
    padding-right: 35px;

    button {
        z-index: 15;
    }
}

.wrap {
    padding-top: 0 !important;
}

.hovered-line:hover {
    background-color: rgba(0, 0, 0, 0.2);
}

.user-item {
    cursor: pointer;
}

.ManualBtndelete {
    background-color: #d9534f !important;
}

.ManualBtncancel {
    color: white !important;
    background-color: #00a8ca !important;
    border-color: #ccc !important;
}

.ManualBtn {
    display: inline-block !important;
    margin-bottom: 0 !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    -ms-touch-action: manipulation !important;
    touch-action: manipulation !important;
    cursor: pointer !important;
    background-image: none !important;
    border: 1px solid transparent !important;
    padding: 6px 12px !important;
    font-size: 14px !important;
    line-height: 1.42857143 !important;
    border-radius: 4px !important;
    color: #fff !important;
}

.full-btn {
    padding-right: 20px !important;
    padding-left: 10px !important;
}

button.md-button.ManualBtn.ManualBtndelete.md-theme-default span.md-button-content {
    font-size: 15px;
}

button.md-button.ManualBtn.ManualBtncancel.md-theme-default span.md-button-content {
    font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/UsersSettings.vue